module.exports = __webpack_public_path__ + "static/media/image_50.4d0b1741.png";